import React from "react";
import Commons from '../../util/commons';
var { QRCodeSVG: QRCode } = require('qrcode.react');

class FluxTemplateComponent extends React.Component {

    wrapText = (text, maxCharsPerLine = 80) => {
        if (!text) return '';
        return text.split('\n').map(line => {
            if (line.length <= maxCharsPerLine) return line;
            const words = line.split(' ');
            const wrappedLines = [];
            let current = '';
            for (const word of words) {
                if ((current + (current ? ' ' : '') + word).length > maxCharsPerLine && current) {
                    wrappedLines.push(current);
                    current = word;
                } else {
                    current = current ? current + ' ' + word : word;
                }
            }
            if (current) wrappedLines.push(current);
            return wrappedLines.join('\n');
        }).join('\n');
    }

    qrcodeValue = (invoiceUid) => {
        return window.location.host + "/mydata/" + invoiceUid;
    }

    getLogo = (logo) => {
        if (logo) {
            if (!logo.includes("blob:")) logo += "?" + Date.now();
            return <img alt="" src={logo} className="f-logo" />;
        }
    }

    createMoreTaxesTable(saleInstanceMoreTaxes, lang) {
        var rows = [];
        var types = [];
        saleInstanceMoreTaxes.sort((a, b) => a.myDataMoreTax.type.localeCompare(b.myDataMoreTax.type));
        saleInstanceMoreTaxes.forEach(e => {
            var type = e.myDataMoreTax.type;
            if (type === "DEDUCTION" && e.myDataMoreTax.label) {
                e.deduction = e.myDataMoreTax;
                e.deduction.name = e.myDataMoreTax.label;
            }
            if (e.deduction) type = "DEDUCTION";
            if (!types.includes(e.myDataMoreTax.type)) {
                types.push(e.myDataMoreTax.type);
            } else {
                type = "";
            }
            var TAX = e.myDataMoreTax ? "TAX_" + e.myDataMoreTax.uid : null;
            if (e.deduction) {
                rows.push(<tr key={Math.random()} className="f-tax-row"><td>{this.props.t(type, { lng: lang })}</td><td>{e.deduction.name}</td><td className="f-td-r">{e.amount}</td></tr>);
            } else {
                rows.push(<tr key={Math.random()} className="f-tax-row"><td>{this.props.t(type, { lng: lang })}</td><td>{this.props.t(TAX, { lng: lang })}</td><td className="f-td-r">{e.amount}</td></tr>);
            }
        });
        return rows;
    }

    createEntries = (entries) => {
        var rows = [];
        if (!entries) return rows;
        entries = entries.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));
        const sale = this.props.sale;
        const lang = sale ? sale.TEMPLATE_LANG : undefined;
        const showMu = sale ? !Commons.isOnGroup(sale.MYDATA_INVOICE_TYPE, "noMeasurementUnit") : true;

        entries.forEach(entry => {
            const isEmpty = !entry.NAME_LIST;
            rows.push(
                <tr key={"entry_" + entry.id} className={isEmpty ? "f-row f-row-empty" : "f-row"}>
                    <td className="f-td-name"><small>{entry.NAME_LIST}</small></td>
                    <td className="f-td-r">{entry.QUANTITY_LIST}</td>
                    {showMu && <td className="f-td-r">{this.props.t(entry.MU_LIST, { lng: lang })}</td>}
                    <td className="f-td-r">{entry.UP_LIST}</td>
                    <td className="f-td-r">{entry.DISCOUNT}</td>
                    <td className="f-td-r">{entry.VAT_LIST}{entry.VAT_LIST ? "%" : ""}</td>
                    <td className="f-td-r">{entry.PRICE_NOVAT_LIST}</td>
                    <td className="f-td-r f-td-total">{entry.PRICE_LIST}</td>
                </tr>
            );
        });
        return rows;
    }

    createPage = (sale) => {
        const lang = sale.TEMPLATE_LANG;
        const t = (key, opts) => this.props.t(key, { lng: lang, ...opts });
        const showMu = !Commons.isOnGroup(sale.MYDATA_INVOICE_TYPE, "noMeasurementUnit");
        const showMove = sale.MOVE_PURPOSE || sale.VEHICLE_NUMBER || sale.DISPATCH_DATE || sale.LOADING_ADDRESS || sale.DELIVERY_ADDRESS;

        return (
            <div className="f-invoice-box" key={"box_" + Math.floor(Math.random() * 10000)}>

                {/* ── LEFT SPINE ── */}
                <div className="f-spine"></div>

                {/* ── INNER CONTENT (offset by spine) ── */}
                <div className="f-inner">

                    {/* ── HEADER ── */}
                    <div className="f-header">
                        <div className="f-header-left">
                            <div className="f-issuer-name">{sale.ISSUER_NAME}</div>
                            {sale.ISSUER_SUBJECTFIELD && <div className="f-issuer-sub">{sale.ISSUER_SUBJECTFIELD}</div>}
                            <div className="f-issuer-meta">
                                {sale.ISSUER_ADDRESS && <span>{sale.ISSUER_ADDRESS}</span>}
                                {sale.ISSUER_VAT && <span className="f-meta-dot">{t("TAXPAYER_ID")}: {sale.ISSUER_VAT}</span>}
                                {sale.ISSUER_DOY && <span className="f-meta-dot">{t("DOY")}: {sale.ISSUER_DOY}</span>}
                                {sale.ISSUER_GEMH && <span className="f-meta-dot">{t("GEMH")}: {sale.ISSUER_GEMH}</span>}
                            </div>
                            <div className="f-issuer-meta">
                                {sale.ISSUER_PHONE && <span>{t("PHONE")}: {sale.ISSUER_PHONE}</span>}
                                {sale.ISSUER_EMAIL && <span className="f-meta-dot">{t("EMAIL")}: {sale.ISSUER_EMAIL}</span>}
                            </div>
                        </div>
                        <div className="f-header-right">
                            {this.getLogo(sale.LOGO)}
                        </div>
                    </div>

                    {/* ── INVOICE BAND ── */}
                    <div className="f-invoice-band">
                        <div className="f-band-type">{sale.INVOICE_TYPE}</div>
                        <div className="f-band-center">
                            <div className="f-band-number-lbl">{t("Number")}</div>
                            <div className="f-band-number">{sale.INVOICE_NUMBER}</div>
                        </div>
                        <div className="f-band-right">
                            <div className="f-band-date-lbl">{t("IssueDate")}</div>
                            <div className="f-band-date">{sale.INVOICE_DATE}</div>
                            {sale.INVOICE_TIME && <div className="f-band-time">{sale.INVOICE_TIME}</div>}
                        </div>
                    </div>

                    {/* ── PARTIES ── */}
                    <div className="f-parties">
                        <div className="f-party f-party-customer">
                            <div className="f-party-label">{t("customerSection")}</div>
                            <div className="f-party-name">{sale.CP_NAME}</div>
                            {sale.CP_SUBJECT_FIELD && <div className="f-party-row">{sale.CP_SUBJECT_FIELD}</div>}
                            {sale.CP_ADDRESS && <div className="f-party-row">{sale.CP_ADDRESS}</div>}
                            {(sale.CP_CITY || sale.COUNTRY) && (
                                <div className="f-party-row">{sale.CP_CITY}{sale.COUNTRY ? ", " + t(sale.COUNTRY) : ""}</div>
                            )}
                            {sale.CP_VAT && <div className="f-party-row"><span className="f-lbl">{t("TAXPAYER_ID")}:</span> {sale.CP_VAT}</div>}
                            {sale.CP_TAXOFFICE && <div className="f-party-row"><span className="f-lbl">{t("DOY")}:</span> {sale.CP_TAXOFFICE}</div>}
                            {sale.CP_PAYTYPE && <div className="f-party-row"><span className="f-lbl">{t("CP_PAYTYPE")}:</span> {t(sale.CP_PAYTYPE)}</div>}
                        </div>
                        {showMove && (
                            <div className="f-party f-party-transport">
                                <div className="f-party-label">{t("moveSection")}</div>
                                {sale.MOVE_PURPOSE && <div className="f-party-row"><span className="f-lbl">{t("MOVE_PURPOSE")}:</span> {sale.MOVE_PURPOSE}</div>}
                                {sale.VEHICLE_NUMBER && <div className="f-party-row"><span className="f-lbl">{t("VEHICLE_NUMBER")}:</span> {sale.VEHICLE_NUMBER}</div>}
                                {sale.DISPATCH_DATE && <div className="f-party-row"><span className="f-lbl">{t("DISPATCH_DATE")}:</span> {sale.DISPATCH_DATE}</div>}
                                {sale.LOADING_ADDRESS && <div className="f-party-row"><span className="f-lbl">{t("LOADING_ADDRESS")}:</span> {sale.LOADING_ADDRESS}</div>}
                                {sale.DELIVERY_ADDRESS && <div className="f-party-row"><span className="f-lbl">{t("DELIVERY_ADDRESS")}:</span> {sale.DELIVERY_ADDRESS}</div>}
                            </div>
                        )}
                    </div>

                    {/* ── PRODUCT TABLE ── */}
                    <div className="f-table-wrap">
                        <table className="f-product-table">
                            <thead>
                                <tr>
                                    <th className="f-th-name">{t("PROD_SERV")}</th>
                                    <th className="f-th-r">{t("QUANTITY")}</th>
                                    {showMu && <th className="f-th-r">{t("MUN")}</th>}
                                    <th className="f-th-r">{t("UNIT_PRICE")}</th>
                                    <th className="f-th-r">{t("DISCOUNT")}</th>
                                    <th className="f-th-r">{t("VAT")} %</th>
                                    <th className="f-th-r">{t("PRICE_WITHOUT_VAT")}</th>
                                    <th className="f-th-r">{t("PRICE_WITH_VAT")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.createEntries(sale.entries)}
                            </tbody>
                        </table>
                    </div>

                    {/* ── BOTTOM (pinned) ── */}
                    <div className="f-bottom-section">

                        <div className="f-footer-section">
                            <div className="f-footer-left">
                                <div className="f-notes-block">
                                    <div className="f-block-lbl">{t("NOTES")}</div>
                                    <div className="f-notes-text" style={{ whiteSpace: 'pre-wrap' }}>{this.wrapText(sale.NOTES)}</div>
                                </div>
                                {sale.saleInstanceMoreTaxes && sale.saleInstanceMoreTaxes.length > 0 && (
                                    <table className="f-moretax-table">
                                        <tbody>
                                            {this.createMoreTaxesTable(sale.saleInstanceMoreTaxes, lang)}
                                        </tbody>
                                    </table>
                                )}
                                <div className="f-qr-wrap">
                                    <QRCode
                                        size={72}
                                        bgColor="#ffffff"
                                        fgColor={this.props.mainStyle ? (this.props.mainStyle.match(/--appcolor:\s*([^;]+)/)?.[1]?.trim() || "#0d6e6e") : "#0d6e6e"}
                                        level="L"
                                        marginSize={0}
                                        value={sale.QRURL ? sale.QRURL : this.qrcodeValue(sale.INVOICEUID)}
                                    />
                                </div>
                            </div>

                            <div className="f-footer-right">
                                {!Commons.isOnGroup(sale.MYDATA_INVOICE_TYPE, "noCountItems") && (
                                    <div className="f-count-items">
                                        {t("TOTALITEMS")}: <strong>{sale.TOTALCOUNTITEMS}</strong>
                                    </div>
                                )}
                                <table className="f-totals-table">
                                    <tbody>
                                        <tr>
                                            <td>{t("TOTALVALUE")}</td>
                                            <td className="f-td-r">{sale.TOTALNODISCOUNT}</td>
                                        </tr>
                                        <tr>
                                            <td>{t("DISCOUNT")}</td>
                                            <td className="f-td-r">{sale.TOTALDISCOUNT}</td>
                                        </tr>
                                        <tr>
                                            <td>{t("VATVALUE")}</td>
                                            <td className="f-td-r">{sale.TOTALVAT}</td>
                                        </tr>
                                        {sale.TOTALTAXES && (
                                            <tr>
                                                <td>{t("MORETAXES")}</td>
                                                <td className="f-td-r">{sale.TOTALTAXES}</td>
                                            </tr>
                                        )}
                                        <tr className="f-total-final">
                                            <td>{t("PAYAMOUNT")}</td>
                                            <td className="f-td-r">{sale.TOTALPAYMENT}</td>
                                        </tr>
                                        {sale.CURRENCY && sale.CURRENCY !== "EUR" && (
                                            <tr>
                                                <td>{t("TOTALPAYMENT_ON_CURRENCY", { currency: sale.CURRENCY })}</td>
                                                <td className="f-td-r">{sale.TOTALPAYMENT_ON_CURRENCY} <span className="f-currency">{sale.CURRENCY}</span></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                {sale.IBAN && <div className="f-iban">{sale.IBAN}</div>}
                                <div className="f-signatures">
                                    <div className="f-sign-box">
                                        <div className="f-sign-lbl">{t("ISSUANCE")}</div>
                                        <div className="f-sign-line"></div>
                                        <div className="f-sign-sub">{t("Signature")}</div>
                                    </div>
                                    <div className="f-sign-box">
                                        <div className="f-sign-lbl">{t("RECEIPT")}</div>
                                        <div className="f-sign-line"></div>
                                        <div className="f-sign-sub">{t("Signature")}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {(sale.VAT_EXCEPTION_CATEGORIES?.[0] || sale.MOREINFO || sale.CORRELATIVE_INVOICE) && (
                            <div className="f-extra-info">
                                {sale.VAT_EXCEPTION_CATEGORIES?.[0] && (
                                    <div><small><strong>{t("vatCategoryExceptionShort")}:</strong> {t(sale.VAT_EXCEPTION_CATEGORIES[0])}</small></div>
                                )}
                                {sale.MOREINFO && <div>{t(sale.MOREINFO)}</div>}
                                {sale.CORRELATIVE_INVOICE && <div><small>{t("correlativeSales")} {t(sale.CORRELATIVE_INVOICE)}</small></div>}
                            </div>
                        )}

                        <div className="f-mydata-footer">
                            <div className="f-mydata-row">
                                {sale.INVOICEUID && (
                                    <span><span className="f-mydata-lbl">uid:</span> <span className="f-mydata-val">{sale.INVOICEUID}</span></span>
                                )}
                                {sale.INVOICEMARK
                                    ? <span><span className="f-mydata-lbl">mark:</span> <span className="f-mydata-val">{sale.INVOICEMARK}</span></span>
                                    : <span className="f-not-published">{t("notPublished")}</span>
                                }
                                {sale.CANCELATIONMARK && (
                                    <span><span className="f-mydata-lbl">cancelationMark:</span> <span className="f-mydata-val">{sale.CANCELATIONMARK}</span></span>
                                )}
                            </div>
                            <div className="f-createdby">{t("CREATEDBY")}</div>
                        </div>

                    </div>{/* end f-bottom-section */}

                </div>{/* end f-inner */}
            </div>
        );
    }

    createPages = (sale) => {
        var pages = [];
        var chunk = 13;
        if (sale && sale.INVOICE_ENTRIES != undefined) {
            for (var i = 0, j = sale.INVOICE_ENTRIES.length; i < j; i += chunk) {
                var groupEntries = sale.INVOICE_ENTRIES.slice(i, i + chunk);
                var groupSale = Object.assign({}, sale, { entries: groupEntries });
                pages.push(this.createPage(groupSale));
            }
        }
        return pages;
    }

    getMainStyle = () => {
        if (this.props.mainStyle) return <style>{this.props.mainStyle}</style>;
    }

    getExtraCss = () => {
        if (this.props.extracss) return <style>{this.props.extracss}</style>;
    }

    render() {
        return (
            <div id="template_page" className="page template_page">
                <link type="text/css" rel="stylesheet" href="../template-flux.css" />
                <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap" rel="stylesheet" type="text/css" />
                {this.getMainStyle()}
                {this.getExtraCss()}
                {this.createPages(this.props.sale)}
            </div>
        );
    }
}

export default FluxTemplateComponent;
